import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import omit from 'lodash/omit'

import settings from './modules/settings'
import user from './modules/user'
import userRoles from './modules/userRoles'
import userModule from './modules/userModule'
import exports from './modules/export'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'energybalance',
  reducer: state => {
    return omit(state, ['settings.alert'])
  }
})

export default new Vuex.Store({
  modules: {
    settings,
    user,
    userRoles,
    exports,
    userModule
  },
  strict: debug,
  plugins: [vuexLocal.plugin]
})
